module.exports = __webpack_public_path__ + "accf2275fa60f65ca88906a9af1f5bd3.woff2";